import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LinearControparteCmp from "../../components/driver/LinearControparteCmp";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import LoaderCmp from "../../components/loader/LoaderCmp";
import { LNextButton, SecondChoiseButton } from "../../components/styled/Button.style";
import { LTitleIconSection, Section } from "../../components/styled/Containers.style";
import { LIconContainer } from "../../components/styled/Icon.style";
import { Vspace } from '../../components/styled/Separators.style';
import { LPageTitle, LSimpleText } from "../../components/styled/Text.style";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { selectCommunicationData } from "../../store";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { CommunicationType, EventCommType, EventValueEnum, LinearContactInfo, LinearControparteInfo } from "../../types/communication/communicationDataType";
import { CaiSideType, SignCaiBodyType } from "../../types/communication/sign-type";
import { usePrivacyCheckCmp } from "../../utils/hooks/usePrivacyCheckCmp";
import { isExpired48h } from "../../utils/time.utils";
import { composeUrl } from "../../utils/utils";
import PageContainerCmp from "../PageContainerCmp";

const SignatureProposalPageLinear = () => {
    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const navigate = useNavigate();
    const { communication, invokeSignatureMetadata } = communicationData
    const { token, linearControparteInfo } = communication;

    const [controparteInfo, setControparteInfo] = useState<LinearControparteInfo>(linearControparteInfo)
    const { privChecked, PrivCheckedCmp } = usePrivacyCheckCmp(communication.authConfirmPrivacyChecked, communication?.companyName)

    const goToNextStepHandler = () => {
        const hasAgreedWithCtp = controparteInfo.agreeWithCtp === true

        let newEvent = new EventCommType({ value: EventValueEnum.LINEAR_START_SIGNATURE_SEND_FOR_CTP_AUTH });
        if (hasAgreedWithCtp === false || isExpired48h(communication?.creation_date)) {
            newEvent = new EventCommType({ value: EventValueEnum.LINEAR_START_ONE_SIGNATURE });
        }
        const newLinearControparteInfo = {
            ...communication.controparteInfo,
            agreeWithCtp: hasAgreedWithCtp,
            agree_contactInfo: hasAgreedWithCtp
                ? new LinearContactInfo(controparteInfo.agree_contactInfo)
                : new LinearContactInfo() // versione "pulita"
        }
        const vehicleB: CaiSideType = {
            ...communication?.caiData?.data?.vehicleB!,
            driver: {
                ...communication?.caiData?.data?.vehicleB?.driver!,
                name: controparteInfo.agree_contactInfo.name,
                surname: controparteInfo.agree_contactInfo.surname,
                telNumber: controparteInfo.agree_contactInfo.phoneNumber,
            },
        }
        const updatedCaiData: SignCaiBodyType = {
            ...communication?.caiData!,
            data: {
                ...communication?.caiData?.data,
                vehicleB
            },
        }
        const data = new CommunicationType({
            ...communication,
            authConfirmPrivacyChecked: privChecked.value,
            linearControparteInfo: newLinearControparteInfo,
            caiData: updatedCaiData
        })
        /* istanbul ignore next */
        dispatch(saveCommunicationAct({
            data,
            events: [newEvent],
            callback: () => navigate(composeUrl(token, LINEAR_PATHS.CHOOSE_SIGNATURE_AUTHENTICATION, LINEAR_BASE_ROUTE))
        }))
    }

    const goToPreviousStepHandler = () => {
        let nextPath = composeUrl(token, LINEAR_PATHS.QUESTION_AGREEMENT_PAGE, LINEAR_BASE_ROUTE)
        /*if (isExpired48h(communication?.creation_date)) {
            nextPath = composeUrl(token, LINEAR_PATHS.FIRMA_DIGITALE_PAGE, LINEAR_BASE_ROUTE)
        }*/
        navigate(nextPath)
    }

    const isCaiStepValid = (
        isExpired48h(communication?.creation_date) ||
        controparteInfo.agreeWithCtp === false ||
        (controparteInfo?.agree_contactInfo?.name &&
            controparteInfo?.agree_contactInfo?.surname &&
            controparteInfo?.agree_contactInfo?.phoneNumber)
    )

    return (
        <>

            <PageContainerCmp
                routePath={LINEAR_PATHS.SIGNATURE_PROPOSAL_PAGE}
                removeNextBtn
            >
                {invokeSignatureMetadata?.isLoading && <LoaderCmp className="cover cai-preview" />}

                <Section linear={true}>
                    <LTitleIconSection style={{ marginLeft: "10px" }}>
                        <LIconContainer><FontAwesomeIcon fontSize={24} icon={faChevronLeft} onClick={goToPreviousStepHandler} /></LIconContainer>
                        <LPageTitle style={{ marginLeft: "20px" }}>{(linearControparteInfo?.agreeWithCtp === false || isExpired48h(communication?.creation_date)) ? "Firma senza l'altro conducente" : "DATI CONTROPARTE"}</LPageTitle>
                    </LTitleIconSection>

                    <Vspace qty={2}></Vspace>

                    {(linearControparteInfo?.agreeWithCtp === false || isExpired48h(communication?.creation_date)) ? <>
                        {linearControparteInfo?.agreeWithCtp === false && <LSimpleText>Se non sei d'accordo con l’altro conducente sulla dinamica dell’incidente o non hai il suo numero di cellulare, puoi comunque procedere con la tua firma.</LSimpleText>}
                        {isExpired48h(communication?.creation_date) && <LSimpleText>Le 48 ore per l'invio della CAI alla controparte sono scadute: ti chiediamo di firmare la tua CAI per permetterci di raccogliere la denuncia e procedere con la pratica.</LSimpleText>}
                        <Vspace qty={12}></Vspace>
                    </> : <LinearControparteCmp
                        initValues={controparteInfo}
                        onChange={(newInfo: Partial<LinearControparteInfo>) => setControparteInfo(currInfo => ({
                            ...currInfo,
                            ...newInfo
                        }))}
                    />}

                    {PrivCheckedCmp}

                    <LNextButton
                        disabled={!privChecked?.value || !isCaiStepValid}
                        onClick={goToNextStepHandler}
                        style={{ height: "auto" }}
                    >
                        PROCEDI CON LA FIRMA
                    </LNextButton>

                    <Vspace qty={2}></Vspace>

                    <SecondChoiseButton linear={true} onClick={goToPreviousStepHandler}>Torna indietro</SecondChoiseButton>

                    <Vspace qty={2}></Vspace>

                </Section>

                <LinearFooterCmp />

            </PageContainerCmp>
        </>

    )
}

export default SignatureProposalPageLinear